import React, { useMemo } from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { Grid, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

// Internal Dependencies
import Sortable from '../common/sortable';
import GridList from '../common/gridList';

const HeaderTitle = 'Display First In App';
const FooterTitle = 'Display Last In App';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding:   theme.spacing(1),
    textAlign: 'center',
    color:     theme.palette.text.secondary,
  },
}));

const HighlightSortable = (props) => {
  const classes = useStyles();
  const sortedData = useMemo(
    () => [...props.data].sort((a, b) => a.displayOrder - b.displayOrder),
    [props.data],
  );

  return (
    <>
      <Grid container item sm={12}>
        <Grid item xs={12}>
          <Paper className={classes.paper} elevation={0}>
            <Typography variant="subtitle2">{HeaderTitle.toUpperCase()}</Typography>
          </Paper>
        </Grid>
      </Grid>
      <hr />
      <Sortable
        data={sortedData}
        handleSort={props.handleSort}
        renderItem={(item) => <GridList value={item} />}
      />
      <hr />
      <Grid container item sm={12}>
        <Grid item xs={12}>
          <center>
            <Paper className={classes.paper} elevation={0}>
              <Typography variant="subtitle2">{FooterTitle.toUpperCase()}</Typography>
            </Paper>
          </center>
        </Grid>
      </Grid>
    </>
  );
};

HighlightSortable.propTypes = {
  data:       PropTypes.arrayOf(PropTypes.shape(Object)).isRequired,
  handleSort: PropTypes.func.isRequired,
};

export default HighlightSortable;
